import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserCreate } from 'src/models/User.interface';


@Component({
  selector: 'app-user-form-modal',
  templateUrl: './user-form-modal.component.html',
  styleUrls: ['./user-form-modal.component.css']
})
export class UserFormModalComponent implements OnInit {
  userForm!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<UserFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      role: ['', [Validators.required]]
    })
  }

  handleCreateUser(): void {
    if (this.userForm.valid) {
      const newUser: UserCreate = {
        email: this.userForm.get('email')?.value,
        password: this.userForm.get('password')?.value,
        role: this.userForm.get('role')?.value
      }
      this.dialogRef.close(newUser);
    }
  }


  closeModal(): void {
    this.dialogRef.close();
  }

}
